import { VolumeDiscountScale } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApi } from './fetchFromApi';

export const fetchProductTypeDiscounts = (productTypeId: string) =>
  fetchFromApi<{ discountScales: VolumeDiscountScale[] }>(
    `${getParams().context}s/${getParams().contextId}/discountScales`,
    { fullData: true, productTypeId }
  ).then((data) => data.discountScales);
